import React from 'react';
import styled from 'styled-components';
import { ImageInfoContent, infoStyles } from './image-info-modal';

// Rendered in a portal above PhotoSwipe (its root is z-index 100000)
const PANEL_WIDTH = 380;
const Z_INDEX = 100001;

const PanelBody = styled.div`
  ${infoStyles}
`;

const toggleStyle = (open) => ({
  position: 'fixed',
  top: '70px',
  right: open ? `${PANEL_WIDTH + 16}px` : '16px',
  zIndex: Z_INDEX + 1,
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  padding: '8px 12px',
  fontSize: '13px',
  fontWeight: '600',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  transition: 'right 0.2s'
});

const panelStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  width: `${PANEL_WIDTH}px`,
  maxWidth: '100vw',
  zIndex: Z_INDEX,
  display: 'flex',
  flexDirection: 'column',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.4)'
};

const headerStyle = {
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  padding: '14px 16px',
  flexShrink: 0
};

const footerStyle = {
  padding: '12px 16px',
  borderTop: '1px solid rgba(0, 0, 0, 0.1)',
  flexShrink: 0
};

const deleteButtonStyle = {
  width: '100%',
  background: 'linear-gradient(135deg, #cb2d3e 0%, #ef473a 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  padding: '10px',
  fontWeight: '600',
  cursor: 'pointer'
};

const FullscreenAdminPanel = ({ galleryId, albumName, fileName, open, onToggle, onDelete }) => (
  <>
    <button type="button" onClick={onToggle} title="Show image info" style={toggleStyle(open)}>
      ℹ️ Info
    </button>
    {open && (
      <aside style={panelStyle}>
        <div style={headerStyle}>
          <div style={{ fontWeight: '700', fontSize: '18px' }}>Image Info</div>
          <div style={{ fontSize: '12px', opacity: 0.9, wordBreak: 'break-all' }}>{fileName}</div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px' }}>
          <PanelBody>
            <ImageInfoContent galleryId={galleryId} albumName={albumName} fileName={fileName} />
          </PanelBody>
        </div>
        <div style={footerStyle}>
          <button type="button" onClick={onDelete} title="Delete image permanently" style={deleteButtonStyle}>
            🗑️ Delete image permanently
          </button>
        </div>
      </aside>
    )}
  </>
);

export default FullscreenAdminPanel;
